import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import { landingActiveStepAtom, landingActiveStepErrorsAtom } from "../atoms";
import { LandingStepEnum } from "../enums";
import { ILandingActiveStepError } from "../models";
import { usePrefixedRoutingLandings } from "./use-prefixed-routing-landings";

export const useLandingActions = () => {
  const { navigateLandingPrefixed, prefix } = usePrefixedRoutingLandings();
  const setCurrentStep = useSetRecoilState(landingActiveStepAtom);
  const setCurrentStepError = useSetRecoilState(landingActiveStepErrorsAtom);
  const location = useLocation();

  const isStepsPathValid = useMemo(
    (): boolean => location.pathname.includes(prefix),
    [location.pathname, prefix],
  );

  const goToStep = useEvent(
    (
      step: LandingStepEnum,
      queryParams?: Record<string, string | number>,
    ): void => {
      let queryString = "";

      if (queryParams && Object.keys(queryParams)?.length > 0) {
        queryString = `?${new URLSearchParams(queryParams as Record<string, string>).toString()}`;
      }

      setCurrentStep(step);

      if (queryString || !isStepsPathValid) {
        navigateLandingPrefixed(queryString);
      }
    },
  );

  const setActiveStepErrors = (
    activeStepError: ILandingActiveStepError,
  ): void => {
    setCurrentStepError(activeStepError);
  };

  return { goToStep, setActiveStepErrors };
};
